export default __webpack_public_path__ + "static/media/hover_hotel_map.5897361c.png";